<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete" v-if="clients && !isCartographie">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ $t('listeClients.title')}}</h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <router-link :to="{name: 'm.bodac.clients/contacts-addClient'}">
              <a class="button is-addOrEdit"
                 :class="{
                   'button-access-no-permission' : !checkPermissions(permClientsContacts.maj)
                   }"
              >
                {{ $t('listeClients.actions.newCustomer')}}
              </a>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="manageActions"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="elementSelectionnes"
            ></selecteur-action>
          </div>
          <form @submit.prevent="recherche()"
                class="column is-6 pdr-0">
            <b-input :placeholder="$t('listeClients.actions.search')"
                     type="search"
                     icon="magnify" expanded
                     v-model="criteresRecherche.auto">
            </b-input>
          </form>
          <div class="column is-narrow">
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('listeClients.actions.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiser()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="columns level-right">
        <div class="column is-narrow" v-if="!isCartographie">
          <exportExcelButton
            :perm="permClientsContacts.exporter"
            :query="exportExcelQuery"
            :secondaryExports="secondaryActions"/>
        </div>
        <parametrage-table
          v-if="!isCartographie"
          :reference-table="referenceTable">
        </parametrage-table>
      </div>
    </div>
    <v-server-table
      v-if="startArrayRendering"
      url=""
      :columns="columns"
      :options="options"
      @loaded="finLoading"
      @loading="debutLoading"
      :ref="referenceTable">
      <template slot='afterTable'>
        <table-items-in-view @input="$refs[referenceTable].setLimit($event)" />
      </template>
      <template slot="code" slot-scope="props">
        <div class="is-flex is-justify-content-space-between is-align-items-start">
          <div class="level-left">
            {{ props.row.code }}
          </div>
          <div class="is-flex is-flex-direction-column mgl-2">
            <tag-list
              v-if="getListeTags(props.row)"
              :listes="getListeTags(props.row)"/>
          </div>
          <div class="level-right is-flex">
            <niveau-blocage-icone
              v-if="props.row.blocageLevel"
              :niveau="props.row.blocageLevel"
              :description="props.row.descriptionBlocage"
              size="is-small"/>
          </div>
        </div>
      </template>
      <div slot="adresse" slot-scope="props">
        <span v-if="props.row.adressePostale">{{props.row.adressePostale.adresse1}}</span>
      </div>
      <div slot="codePostal" slot-scope="props">
        <span v-if="props.row.adressePostale">{{props.row.adressePostale.codePostal}}</span>
      </div>
      <div slot="ville" slot-scope="props">
        <span v-if="props.row.adressePostale">{{props.row.adressePostale.ville}}</span>
      </div>
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.selected"
                    :value="props.row"
                    @input="selectionClient()">
        </b-checkbox>
      </div>
      <div slot="nomCommercial" slot-scope="props">
        <router-link :to="{ name: 'c.bodac.clients/contacts-client', params: {id: props.row.id}}"
                     class="lien" :class="{'text-access-no-permission':
                                   !checkPermissions(permClientsContacts.lecture)}">
          {{props.row.nomCommercial}}
        </router-link>
        <b-tooltip :label="$t('listeClients.table.prospect')" class="mgl-10px"
                   v-if="props.row.prospect"
                   type="is-warning"
                   position="is-right">
          <b-icon icon="account-search" class="is-cursor-pointer mgr-5px"
                  size="is-small"
                  type="is-warning">
          </b-icon>
        </b-tooltip>
      </div>
      <div slot="modifier" slot-scope="props" class="has-text-centered">
        <router-link
          :to="{ name: 'm.bodac.clients/contacts-editClient', params: {id: props.row.id}}">
          <b-icon
            icon="pencil-box-outline"
            type="is-success"
            :class="{ 'text-access-no-permission' : !checkPermissions(permClientsContacts.maj) }"
          >
          </b-icon>
        </router-link>
      </div>
      <div slot="archiver" slot-scope="props" class="has-text-centered">
        <a @click="checkPermissions(permClientsContacts.supprimer) ?
          openPopUpArchivage(props.row) : showPopUp()">
          <b-icon
            :icon="props.row.archive ? 'archive-arrow-up' : 'archive'"
            type="is-default"
            :class="{
              'text-access-no-permission' : !checkPermissions(permClientsContacts.supprimer)
              }"
          >
          </b-icon>
        </a>
      </div>
      <template slot="supprimer" slot-scope="props">
        <div class="has-text-centered">
          <btn-action-icon
            :tooltip-label="$t('general.button.delete')"
            :permission="permClientsContacts.supprimer"
            :tooltip-position="'is-left'"
            @is-click="actionDeleteClient(props.row)"
            icon-type="is-danger"
            icon="delete-forever">
          </btn-action-icon>
        </div>
      </template>
      <template slot="addSelection" slot-scope="props">
        <button
          @click="$emit(
            isInSelection(props.row) ? 'removeSelection' : 'addSelection',
            [props.row],
          )"
          class="ripple button width-100percent"
          :class="isInSelection(props.row) ? 'is-success' : 'is-primary'">
          <b-icon icon="plus-circle"></b-icon>
        </button>
      </template>
    </v-server-table>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre === true">
        <filtre-liste-client
            :isCartographie="isCartographie"
            ref="filtreListeClient"
            @toggleFiltre="setShowFiltre"
            @recherche="makeRechercheFilter()">
        </filtre-liste-client>
      </div>
    </transition>
    <b-modal v-model="popUpExport"
      has-modal-card>
      <pop-up-export-excel-balance
        :query-tiers="exportExcelQuery.filtres"
        @close="popUpExport = false"/>
    </b-modal>
    <b-modal
      v-if="tiersSelelected"
      v-model="openPopUpDeleteTiers"
      width="400px"
      class="modal"
      has-modal-card>
      <popup-delete-tiers
        @refresh="recherche"
        :tiers="tiersSelelected"/>
    </b-modal>
    <b-modal v-model="isPopUpArchiver"
      has-modal-card
      class="modal">
      <app-archiver-client
        :messHeader="$t(clientAArchiver.messHeader)"
        :messFooter="$t(clientAArchiver.messFooter)"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="isPopUpArchiver = false"
        @yes="archiverDesarchiverClients"/>
    </b-modal>
    <b-modal v-model="popUpEdition" has-modal-card class="modal">
      <pop-up-edition
        :error="errorEdition"
        :choiceEdition="listeChoiceEdition"
        :filtreDates="true"
        @editionChoose="edition">
      </pop-up-edition>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import {
  TEXTS, RESULTS_PER_PAGE, SORT_ICON, NO_PER_PAGE_VALUE,
} from '@/configuration/clientTableConf';
import PopUp from '@/components/general/popUpPrevention';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import AppBreadcrumb from '@/components/general/breadcrumb';
import { TIERS } from '@/configuration/permissionsBodacConf';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import filtreListeClient from '@/components/clients/filtre/filtreListeClient';
import { ACTION_ADD_SELECTION, ACTION_DELETE_SELECTION } from '@/configuration/cartographie/cartographie';
import {
  ACTION_ARCHIVER,
  ACTION_DESARCHIVER,
  ACTION_EDITION_EXTRAIT_COMPTE_TIERS, LISTE_CHOICE_EDITION_TIERS, TYPE_DONNEE_EXTRAIT_COMPTE_TIERS,
} from '@/configuration/tiers/tiersConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import TableItemsInView from '@/components/general/TableItemsInView';
import * as tiersConf from '@/configuration/tiers/tiersConf';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import transform from '@/services/tiers/filters/tiersServerTableDataTransformer';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_CLIENT } from '@/configuration/general/referenceTableConf';
import selecteurAction from '@/components/general/selecteurAction';
import { columnsSplice } from '@/services/general/columns';
import popUpExportExcelBalance from '@/components/tiers/p_exportExcelBalance';
import popupDeleteTiers from '@/components/clients/clients/popupDeleteTiers';
import BtnActionIcon from '@/components/general/btnActionIcon';
import { archiverEnMasse } from '@/api/tiers';
import tagList from '@/components/general/tagList';
import niveauBlocageIcone from '@/components/general/NiveauBlocageIcone';
import popUpEdition from '@/components/factures/p_edition';
import edition from '@/api/edition';
import validationGeneral from '@/services/validation/validation';
import readErrorBlobRequest from '@/services/edition/readBlobRequest';

const Parametres = createNamespacedHelpers('parametres');
const permissions = createNamespacedHelpers('permissions');
const societe = createNamespacedHelpers('societe');

export default {
  name: 'liste-clients',
  props: {
    isCartographie: {
      type: Boolean,
      default: false,
    },
    selection: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      startArrayRendering: false,
      clientSelectionne: false,
      showFiltre: false,
      isPopUpArchiver: false,
      listeChoiceEdition: LISTE_CHOICE_EDITION_TIERS
        .filter(l => l.typeDonnee === TYPE_DONNEE_EXTRAIT_COMPTE_TIERS),
      clientAArchiver: {
        archive: false,
        messHeader: null,
        messFooter: null,
        messSuccess: null,
        messError: null,
        ids: [],
      },
      selectAllValue: false,
      loadingComponent: null,
      messagesPopup: [''],
      isErrorPopup: false,
      permClientsContacts: TIERS,
      unsubscribeValue: null,
      type: tiersConf.TIERS_TYPE_CLIENT,
      referenceTable: REFERENCE_TABLE_CLIENT,
      popUpExport: false,
      tiersSelelected: null,
      openPopUpDeleteTiers: false,
      popUpEdition: false,
      errorEdition: {
        haveError: false,
        messages: [],
        champsVide: [],
        messagesChampsVide: [],
      },
    };
  },
  components: {
    popUpEdition,
    appArchiverClient: PopUp,
    AppBreadcrumb,
    filtreListeClient,
    TableItemsInView,
    selecteurAction,
    parametrageTable,
    exportExcelButton,
    popUpExportExcelBalance,
    BtnActionIcon,
    popupDeleteTiers,
    tagList,
    niveauBlocageIcone,
  },
  beforeDestroy() {
    this.unsubscribeValue();
    if (this.lockMenu) this.setLockMenu(false);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.secteurActivite]);
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      if (this.$route.params.type) this.type = this.$route.params.type;
      if (!this.isCartographie) this.setInformationPage(this.$t('pageGescom.client.liste'));
      if (this.lockMenu) this.setLockMenu(false);
      this.criteresRechercheManager();
      this.startArrayRendering = true;
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...societe.mapGetters({
      lockMenu: 'lockMenu',
      societeActiveId: 'societeActiveId',
    }),
    actions() {
      return [
        {
          action: ACTION_ADD_SELECTION,
          translation: 'cartographie.actions.addSelection',
          show: this.isCartographie,
        },
        {
          action: ACTION_DELETE_SELECTION,
          translation: 'cartographie.actions.removeSelection',
          show: this.isCartographie,
        },
        {
          action: ACTION_ARCHIVER,
          translation: 'listeClients.actions.archive',
          show: true,
        },
        {
          action: ACTION_DESARCHIVER,
          translation: 'listeClients.actions.desarchive',
          show: true,
        },
        {
          action: ACTION_EDITION_EXTRAIT_COMPTE_TIERS,
          translation: 'general.popUpEdition.actions.editionExtraitCompteTiers',
          show: true,
        },
      ].filter(el => el.show);
    },
    elementSelectionnes() {
      return this.clients.some(c => c.selected);
    },
    storeName() {
      return this.isCartographie ? 'clientCartographie' : 'clients';
    },
    clients() {
      return this.$store.getters[`${this.storeName}/clients`];
    },
    totalClients() {
      return this.$store.getters[`${this.storeName}/totalClients`];
    },
    affectations() {
      return this.$store.getters[`${this.storeName}/affectations`];
    },
    criteresRecherche: {
      get() {
        return this.$store.getters[`${this.storeName}/criteresRecherche`];
      },
      set(value) {
        this.$store.commit(`${this.storeName}/SET_CRITERE_RECHERCHE`, value);
      },
    },
    lastPayload() {
      return this.$store.getters[`${this.storeName}/lastPayload`];
    },
    baseTradArchiveComputed() {
      return function baseTrad(aArchiver) {
        if (!aArchiver) return 'archiverClient.archivage';
        return 'archiverClient.desarchivage';
      };
    },
    nombreCritere() {
      const banCritereKey = ['auto', 'archive', 'estLieuStockage'];
      let nbCritere = calculNombreCritere(this.criteresRecherche, banCritereKey);
      if (this.criteresRecherche.archive !== null) nbCritere += 1;
      if (this.criteresRecherche.estLieuStockage !== null) nbCritere += 1;
      return nbCritere > 9 ? '+9' : nbCritere;
    },
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('listeClients.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeClients.title'), route: { name: 'l.bodac.clients/contacts-clients' }, isActive: true },
      ];
      return output;
    },
    iconSelectTotal() {
      if (this.selectAllValue) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    allInSelection() {
      return this.clients.every(client => this.selection?.find(c => c.id === client.id));
    },
    columns() {
      const column = ['selected', 'addSelection', 'code', 'nomCommercial', 'nomJuridique', 'adresse', 'codePostal', 'ville', 'telephone', 'portable', 'email', 'compteComptable', 'modifier', 'archiver', 'supprimer'];
      if (this.isCartographie) {
        columnsSplice(column, 'modifier');
        columnsSplice(column, 'archiver');
        columnsSplice(column, 'supprimer');
      } else {
        columnsSplice(column, 'addSelection');
      }
      return column;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          nomCommercial: this.$i18n.t('listeClients.table.name'),
          nomJuridique: this.$i18n.t('listeClients.table.legalName'),
          adresse: this.$i18n.t('listeClients.table.address'),
          codePostal: this.$i18n.t('listeClients.table.zipCode'),
          ville: this.$i18n.t('listeClients.table.city'),
          telephone: this.$i18n.t('listeClients.table.phone'),
          portable: this.$i18n.t('listeClients.table.cellPhone'),
          email: this.$i18n.t('listeClients.table.email'),
          compteComptable: this.$i18n.t('listeClients.table.accountingCode'),
          modifier: '',
          archiver: '',
          supprimer: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
          addSelection: (h) => {
            return h(
              'button', {
                attrs: {
                  class: `ripple button width-100percent ${this.allInSelection ? 'is-success' : 'is-primary'}`,
                },
                on: {
                  click: () => {
                    this.manageAllInSelection();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: 'plus-circle',
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        sortable: ['code', 'nomCommercial', 'nomJuridique', 'adresse', 'codePostal', 'ville', 'telephone', 'portable', 'email', 'compteComptable'],
        columnsClasses: {
          selected: 'colonneSelected',
          portable: 'colonneTelephone',
          telephone: 'colonneTelephone',
          adresse: 'colonneAdresse',
          addSelection: 'colonneSelected-35 is-paddingless',
        },
        requestFunction: ((data) => {
          if (!data.query) data.query = cloneDeep(this.criteresRecherche);
          data.query.societeId = this.societeActiveId;
          data.query.type = this.type;
          data.query.tagIds = data.query.tagIds.map(t => t.id);
          data.query.sousType = [tiersConf.TIERS_SOUS_TYPE_AUCUN];
          if (data.query.tiers.length > 0) {
            data.query.tiersId = data.query.tiers.map((t) => t.id);
          }
          delete data.query.tiers;
          return this.actionsLoadClients(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.clients,
            count: this.totalClients,
          };
        }),
      };
    },
    exportExcelQuery() {
      return {
        typeDonnee: tiersConf.EXPORT_EXCEL_CLIENTS,
        typeExport: null,
        filtres: transform(this.lastPayload),
      };
    },
    secondaryActions() {
      return [
        {
          action: () => { this.popUpExport = true; },
          libelle: this.$t('listeClients.actions.exportBalance'),
        },
      ];
    },
    tiersSelelectedIds() {
      return this.clients?.filter(c => !!c.selected).map(t => t.id);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    criteresRechercheManager() {
      const copy = cloneDeep(this.criteresRecherche);
      if (copy.secteursActiviteIds?.length > 0) {
        const secteurActiviteActifIds = this.parametre(PARAMETRES_KEYS.secteurActivite)
          .filter(s => s.actif).map(s => s.id);
        copy.secteursActiviteIds = copy.secteursActiviteIds
          .filter(id => secteurActiviteActifIds.includes(id));
      }
      this.criteresRecherche = copy;
    },
    actionsLoadClients(data) {
      return this.$store.dispatch(`${this.storeName}/loadClients`, data);
    },
    isInSelection(row) {
      return this.selection?.find(f => f.id === row.id);
    },
    manageAllInSelection() {
      if (this.allInSelection) {
        this.$emit('removeSelection', this.clients);
      } else {
        this.$emit('addSelection', this.clients);
      }
    },
    async edition(donnees) {
      const loadingComponent = this.$buefy.loading.open();
      this.errorEdition.champsVide = [];
      this.errorEdition.messagesChampsVide = [];
      this.errorEdition.messages = [];
      this.errorEdition.haveError = false;
      try {
        const response = await edition({
          ids: this.tiersSelelectedIds,
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
          parametresAdditionnels: donnees.parametresAdditionnels,
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
        this.popUpEdition = false;
      } catch (e) {
        const errorResponseString = await readErrorBlobRequest(e.response.data);
        const response = JSON.parse(errorResponseString);
        validationGeneral(this.$i18n, { data: response }, this.errorEdition.champsVide,
          this.errorEdition.messages, this.errorEdition.messagesChampsVide);
        this.errorEdition.haveError = true;
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    manageActions(action) {
      switch (action) {
        case ACTION_ADD_SELECTION:
          this.$emit('addSelection', this.clients.filter((el) => el.selected));
          break;
        case ACTION_DELETE_SELECTION:
          this.$emit('removeSelection', this.clients.filter((el) => el.selected));
          break;
        case ACTION_ARCHIVER:
          this.openPopUpArchivageMulti(true);
          break;
        case ACTION_DESARCHIVER:
          this.openPopUpArchivageMulti(false);
          break;
        case ACTION_EDITION_EXTRAIT_COMPTE_TIERS:
          this.popUpEdition = true;
          break;
        default:
          messageErreur(this.$i18n, this.$i18n.t('listeFace.errors.noActionSelect'));
          break;
      }
    },
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    getListeTags(row) {
      return row.tags ? row.tags.map(t => t.tag) : null;
    },
    ...societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeClient.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    selectionClient() {
      this.clientSelectionne = this.clients.filter((el) => { return el.selected; }).length > 0;
    },
    selectAll() {
      this.selectAllValue = !this.selectAllValue;
      this.clients.forEach((el) => {
        el.selected = this.selectAllValue;
      });
      this.clientSelectionne = this.selectAllValue;
    },
    openPopUpArchivage(client) {
      this.clientAArchiver = {
        archive: !client.archive,
        messHeader: this.baseTradArchiveComputed(client.archive) + '.archive',
        messFooter: this.baseTradArchiveComputed(client.archive) + '.archiveContacts',
        messSuccess: this.baseTradArchiveComputed(client.archive) + '.archiveSuccess',
        messError: this.baseTradArchiveComputed(client.archive) + '.messages.error',
        ids: [client.id],
      };
      this.isPopUpArchiver = true;
    },
    openPopUpArchivageMulti(archive) {
      const ids = this.clients.filter((el) => {
        return el.selected;
      }).map(el => el.id);
      this.clientAArchiver = {
        archive: archive,
        messHeader: this.baseTradArchiveComputed(!archive) + (ids.length === 1 ? '.archive' : '.archiveMultiple'),
        messFooter: this.baseTradArchiveComputed(!archive) + (ids.length === 1 ? '.archiveContacts' : '.archiveContactsMultiple'),
        messSuccess: this.baseTradArchiveComputed(!archive) + (ids.length === 1 ? '.archiveSuccess' : '.archiveMultipleSuccess'),
        messError: this.baseTradArchiveComputed(!archive) + '.messages.error',
        ids: ids,
      };
      this.isPopUpArchiver = true;
    },
    async archiverDesarchiverClients() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await archiverEnMasse({
          ids: this.clientAArchiver.ids,
          archiver: this.clientAArchiver.archive,
        });
        messageSucces(this.$t(this.clientAArchiver.messSuccess));
        this.recherche();
      } catch (e) {
        messageErreur(this.$i18n, this.$i18n.t(this.clientAArchiver.messError));
        throw e;
      } finally {
        this.isPopUpArchiver = false;
        this.clientAArchiver = {
          archive: false,
          messHeader: null,
          messFooter: null,
          messSuccess: null,
          messError: null,
          ids: [],
        };
        loadingComponent.close();
      }
    },
    async reinitialiser() {
      await this.$refs.filtreListeClient.initializeFiltre();
      this.$refs.filtreListeClient.viderCritere();
      this.$refs.filtreListeClient.appliquerCritere();
      this.showFiltre = false;
    },
    actionDeleteClient(client) {
      this.tiersSelelected = client;
      this.openPopUpDeleteTiers = true;
    },
  },
};
</script>

<style>

</style>
